import React from 'react'

export class FooterNote extends React.Component {
  render () {
    return (
      <div id='footer-note' className='row'>
        <div className='col-md-12'>
          <p>8 1/2 Festa do Cinema Italiano © 2016 Todos os direitos reservados</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/FooterLinks/FooterNote.js